import type * as FormModelType from "@/components/features/settings/payment-deposit-account/model/type";

export const paymentDepositAccountInputModelFactory = (
	hotelID: string,
): FormModelType.PaymentDepositAccountFormModel["InputModel"] =>
	({
		hotelID,
		minimumTransferAmount: 0,
		bankCode: "",
		bankBranchCode: "",
		bankAccountType: "普通",
		bankAccountNumber: "",
		bankAccountHolderName: "",
	}) satisfies FormModelType.PaymentDepositAccountFormModel["InputModel"];
